import React from 'react';
import ProviderCard from './ProviderCard';
import { Provider } from './types';

interface ProvidersListProps {
  providers: Provider[];
}

const ProvidersList: React.FC<ProvidersListProps> = ({ providers }) => {
  if (providers.length === 0) {
    return (
      <div className="uk-text-center no-results-container">
        <div className="uk-margin-large" style={{ 
          padding: '60px 20px',
          background: 'rgba(255, 255, 255, 0.1)',
          backdropFilter: 'blur(10px)',
          borderRadius: '20px',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          maxWidth: '600px',
          margin: '60px auto',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)'
        }}>
          <div style={{ 
            width: '120px', 
            height: '120px', 
            margin: '0 auto 30px',
            background: 'linear-gradient(135deg, #20D3C7, #17BCBA)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 8px 25px rgba(32, 211, 199, 0.3)'
          }}>
            <i className="fas fa-search" style={{ 
              fontSize: '48px', 
              color: 'white',
              filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))'
            }}></i>
          </div>
          <h3 style={{ 
            color: 'white', 
            fontSize: '28px',
            fontWeight: '600',
            marginBottom: '15px',
            textShadow: '0 2px 4px rgba(0,0,0,0.3)'
          }}>
            No se encontraron proveedores
          </h3>
          <p style={{ 
            color: 'rgba(255, 255, 255, 0.9)', 
            fontSize: '16px',
            lineHeight: '1.6',
            marginBottom: '30px',
            maxWidth: '400px',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}>
            No hay proveedores registrados en esta categoría por el momento. 
            ¡Sé el primero en registrarte y aprovecha esta oportunidad!
          </p>
          <button 
            className="uk-button uk-button-primary" 
            style={{ 
              backgroundColor: '#20D3C7', 
              border: 'none',
              padding: '15px 30px',
              fontSize: '16px',
              fontWeight: '600',
              borderRadius: '50px',
              boxShadow: '0 4px 15px rgba(32, 211, 199, 0.4)',
              transition: 'all 0.3s ease',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 20px rgba(32, 211, 199, 0.6)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 15px rgba(32, 211, 199, 0.4)';
            }}
          >
            <i className="fas fa-plus uk-margin-small-right"></i>
            + REGISTRAR MI EMPRESA
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="uk-grid uk-child-width-1-4@l uk-child-width-1-3@m uk-child-width-1-2@s uk-child-width-1-1" 
         data-uk-grid 
         style={{ display: 'flex', flexWrap: 'wrap', gap: '30px 0' }}>
      {providers.map(provider => (
        <ProviderCard key={provider.id} provider={provider} />
      ))}
    </div>
  );
};

export default ProvidersList;
